module.exports = __webpack_public_path__ + "img/personNeedList_centerBg.73063439.png";